// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-layout[data-v-ce02afdc]{display:grid;grid-template-columns:minmax(-webkit-min-content,20%) auto;grid-template-columns:minmax(min-content,20%) auto;grid-gap:40px;padding:10px 30px;align-items:start}", ""]);
// Exports
module.exports = exports;
